var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout",class:{'fixed-header':_vm.scrollTop>116}},[_c('base-header'),_c('base-main'),_c('base-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }